module.exports = __webpack_public_path__ + "img/1403544305.0272023f.jpg";